/**
 * Notifications have this structure:
 * {
 *   id: string,
 *   title: string,
 *   message: string,
 *   status: "unread" | "read" | "deleted",
 *   date: Date,
 *   data: object
 * }
 */

import { ref, computed } from "vue";
import { defineStore } from "pinia";

export const useNotificationsStore = defineStore("notifications", () => {
  const lsPrefix = localStorage.getItem("cachePrefix") || "";
  const lsKey = lsPrefix + "notifications";
  const all = ref([]);
  const unread = computed(() => all.value.filter(n => n.status === "unread"));
  const read = computed(() => all.value.filter(n => n.status === "read"));

  // Load stored notifications
  function load() {
    const tmp = [];

    // Load stored notifications
    const stored = localStorage.getItem(lsKey);
    if (stored) {
      tmp.push(...JSON.parse(stored));
      tmp.reverse();
    }
  }

  function save() {
    all.value = all.value.filter(n => n.status != "deleted");
    localStorage.setItem(lsKey, JSON.stringify(all.value));
  }

  function markAsRead(id) {
    markAs(id, "read");
  }

  function markAsUnread(id) {
    markAs(id, "unread");
  }

  function markAsDeleted(id) {
    markAs(id, "deleted");
  }

  function markAs(id, status) {
    all.value = all.value.map(n => (n.id === id ? { ...n, status } : n));
    save();
  }

  function add(item) {
    if (all.value.some(n => n.id === item.id)) return;
    all.value.push(item);
    save();
  }

  load();

  return {
    all,
    unread,
    read,
    markAsRead,
    markAsUnread,
    markAsDeleted,
    add
  };
});
